import React from 'react';

interface ErrorMessageProps {
    error: any;
    color?: 'red' | 'blue' | 'green' | 'yellow';
    size?: 'sm' | 'md' | 'lg';
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, color = 'red', size = 'sm' }) => {
    // TODO: Colors not populating correctly -- tailwind not installed?
    const message = error?.message || error;
    if (!message || typeof message !== 'string') return null;

    if (size === 'sm') return <div className={`text-${color}-600 text-sm`}>{message}</div>;
    else if (size === 'md') return <div className={`text-${color}-600 text-md`}>{message}</div>;
    else if (size === 'lg') return <div className={`text-${color}-600 text-lg`}>{message}</div>;
};

export default ErrorMessage;
